// Components==============
import storeWrongAnswer from 'actions/wrongAnswer/store';
import { UserAnswerEntity } from 'components/Exercises/SoundsExercise/SoundsExercise';
import InputField from 'components/UI/InputField/InputField';
import { SoundType } from 'components/UI/LetterBlock/LetterBlock';
import { BoxTypes } from 'components/UI/StatusBox/StatusBox';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { HomeworkContext } from 'screens/Homework/Homework';
import { deConvertArray } from 'utilities/convertArray';
import { convertString } from 'utilities/convertString';
import { defaultTileBarStateValue } from '../Row/Row';
import { TilesContext } from '../Tiles';
import './Text.module.scss';
// =========================

export default function Text({
    text,
    name,
    tileBarStateAnswer,
    alreadyAnswered,
    category_id,
}: {
    text?: string;
    name?: string;
    tileBarStateAnswer?: SoundType[];
    alreadyAnswered?: UserAnswerEntity;
    category_id?: number;
}) {
    const { sequence } = useContext(HomeworkContext);

    const {
        answer,
        setUserIsTypingAnswer,
        setUserAnswers,
        setActiveTileBar,
        setActiveTileBarState,
    } = useContext(TilesContext);
    const [value, setValue] = useState('');
    const [readOnly, setReadOnly] = useState(false);
    const [boxState, setBoxState] = useState<BoxTypes>('initial');
    const [attempts, setAttempts] = useState(0);
    const inputRef = useRef<HTMLInputElement>(null);
    const dispatch = useDispatch();
    const { treatmentId, homeworkId } = useParams() as {
        treatmentId: string;
        homeworkId: string;
    };

    // set box values when answer is already given
    useEffect(() => {
        if (alreadyAnswered) {
            setValue(alreadyAnswered.correctText);
            setReadOnly(true);
            if (alreadyAnswered.correctText === alreadyAnswered.text)
                return setBoxState('correct');
            setBoxState('failed');
            return;
        }
        setValue('');
        setBoxState('initial');
        setAttempts(0);
        setReadOnly(false);
    }, [alreadyAnswered]);

    useEffect(() => {
        if (name === answer?.name) return inputRef?.current?.focus();

        if (!text && !readOnly) inputRef?.current?.focus();
    }, [answer]);

    function storeWrong() {
        dispatch(
            storeWrongAnswer({
                given_answer: value,
                correct_answer: answer?.name,
                metadata: {
                    sequence,
                },
                type: 'word',
                exercise_id: homeworkId,
                exercise_type: 'homework',
                treatment_id: treatmentId,
            })
        );
    }

    function finish(state: BoxTypes) {
        setUserAnswers((prev) => [
            ...prev,
            {
                bars: tileBarStateAnswer!,
                text: value,
                id: answer.id,
                correctBars: deConvertArray(answer?.klanken),
                correctText: answer.name,
                category_id,
            },
        ]);

        setBoxState(state);
        setUserIsTypingAnswer(false);
        setReadOnly(true);
        setActiveTileBar('initial');
        setActiveTileBarState(defaultTileBarStateValue);
        if (state === 'wrong') {
            storeWrong();
            setValue(answer?.name);
            setBoxState('failed');
        }
    }

    function tryAgain() {
        storeWrong();
        setReadOnly(true);
        setBoxState('wrong');
        setTimeout(() => {
            setBoxState('submit');
            setReadOnly(false);
        }, 1500);
    }

    function handleSubmit(e?: React.FormEvent<HTMLFormElement>) {
        e?.preventDefault();
        if (readOnly || !value) return;

        if (convertString(value) === convertString(answer?.name))
            finish('correct');
        else setAttempts((prev) => prev + 1);
    }

    function handleInputClick() {}

    useEffect(() => {
        if (attempts === 0) return;
        if (attempts === 3) finish('wrong');
        else tryAgain();
    }, [attempts]);

    const active = name === answer?.name;

    return (
        <InputField
            boxState={boxState}
            setBoxState={setBoxState}
            readOnly={readOnly}
            value={value}
            setValue={setValue}
            handleSubmit={handleSubmit}
            text={text}
            reference={inputRef}
            active={active}
            handleInputClick={handleInputClick}
        />
    );
}
